import { Modal as PolarisModal } from "@shopify/polaris"
import { observer } from "mobx-react"
import { useCallbackWithLoading } from "polaris-enhance"
import { useMemo } from "react"

import stores from "@/stores"
import { isShopifyEmbedded } from "@/utils/app-bridge"

import ConfirmModal from "./ConfirmModal"
import { ShopifyModal } from "./ShopifyModal"

const ConfirmModalInPage = () => {
  const isEmbed = isShopifyEmbedded()
  const config = stores.CommonStore.confirmModalConfig
  const [loading, handleConfirm] = useCallbackWithLoading(async () => {
    const res = await config?.onConfirm()
    if (res === false) {
      return false
    }
    stores.CommonStore.setConfirmModalConfig(null)
    config?.onClose?.()
  }, [
    config?.onConfirm,
    config?.onClose,
    stores.CommonStore.setConfirmModalConfig,
  ])

  function closeModal() {
    stores.CommonStore.setConfirmModalConfig(null)
  }

  const primaryAction = useMemo(() => {
    if (!config) return
    const { extraPrimaryAction = {} } = config

    return {
      ...extraPrimaryAction,
      loading: loading,
      content: extraPrimaryAction?.content || t("Confirm"),
      tone: extraPrimaryAction?.destructive
        ? "critical"
        : extraPrimaryAction.tone,
      disabled: loading || stores.CommonStore.temporarySchemaFormLoading,
      onAction: async () => {
        const res = await handleConfirm()
        if (res === false) {
          return false
        }
        closeModal()
      },
    }
  }, [
    config,
    handleConfirm,
    loading,
    stores.CommonStore.temporarySchemaFormLoading,
  ])

  if (isEmbed && !config?.showPolarisModalWhenEmbed) {
    return (
      config && (
        <ShopifyModal
          title={config?.title}
          open={!!config}
          onClose={closeModal}
          primaryAction={config.hideActions ? undefined : primaryAction}
          secondaryActions={
            config.hideActions
              ? undefined
              : config?.extraCancelAction
                ? [
                    {
                      onAction: () => {
                        stores.CommonStore.setConfirmModalConfig(null)
                        config.onClose?.()
                        config.onCancel?.()
                      },
                      ...config.extraCancelAction,
                    },
                  ]
                : [
                    {
                      content: t("Cancel"),
                      onAction: () => {
                        stores.CommonStore.setConfirmModalConfig(null)
                        config.onClose?.()
                        config.onCancel?.()
                      },
                    },
                  ]
          }
        >
          {config?.message}
        </ShopifyModal>
      )
    )
  }

  return (
    config && (
      <ConfirmModal
        title={config?.title}
        open={!!config}
        hideActions={config.hideActions}
        onClose={() => {
          stores.CommonStore.setConfirmModalConfig(null)
          config.onClose?.()
        }}
        autoClose={false}
        cancelText={config.extraCancelAction?.content}
        confirmText={config.extraPrimaryAction?.content}
        disabledConfirm={
          config.extraPrimaryAction?.disabled ||
          stores.CommonStore.temporarySchemaFormLoading ||
          loading
        }
        destructiveConfirm={config.extraPrimaryAction?.destructive}
        onConfirm={handleConfirm}
        onCancel={() => {
          config.onCancel?.()
        }}
      >
        <PolarisModal.Section>{config?.message}</PolarisModal.Section>
      </ConfirmModal>
    )
  )
}

export default observer(ConfirmModalInPage)

export * from "./showModal"
